import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'prop-types';
import * as React from 'react';

var useFocus = function useFocus(_ref) {
  var disabled = _ref.disabled,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;
  var inputRef = React.useRef();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  React.useEffect(function () {
    if (disabled && focused) {
      setFocused(false);

      if (onBlur) {
        var target = inputRef.current;
        var event = {
          target: target
        };
        onBlur(event);
      }
    }
  }, [disabled, focused, onBlur, inputRef]);

  var handleFocus = function handleFocus(e) {
    if (disabled) {
      e.stopPropagation();
      return;
    }

    if (onFocus) onFocus(e);
    setFocused(true);
  };

  var handleBlur = function handleBlur(e) {
    if (onBlur) onBlur(e);
    setFocused(false);
  };

  return {
    inputRef: inputRef,
    focused: focused,
    handleFocus: handleFocus,
    handleBlur: handleBlur
  };
};

export { useFocus };
